import * as apiPut from 'api/ingredient/PutIngredientIdV1';
import * as AllergenList from 'types/BaseIngredient/Detail/AllergenList';
import * as Allergen from 'types/Ingredient/Detail/Allergen';

export type Type = Allergen.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type): apiPut.Allergens {
	const output: apiPut.Allergens = {};
	for (const i of obj) {
		output[i.id] = i.logic;
	}
	return output;
}

export const mapToUniqIdList = AllergenList.mapToUniqIdList;
export const mapFromUniqIdList = AllergenList.mapFromUniqIdList;
export const mapToUniqIdStringArray = AllergenList.mapToUniqIdStringArray;
